import React from 'react';
import { Link } from '@reach/router';
import NotebookLayout from '../../layouts/NotebookLayout/index';
import Input from '../forms/Input';
import { Caps } from '../ui';
import ListItem from './ListItem';

const SearchS = ({ ctx, results, searchTerm, handleSearchTerm }) => (
  <NotebookLayout ctx={ctx}>
    <form
      onSubmit={event => {
        event.preventDefault();
        handleSearchTerm(event.target.searchTerm.value);
      }}
    >
      <Input
        placeholder="Search..."
        name="searchTerm"
        data-testid="search-field"
        defaultValue={searchTerm}
      />
    </form>

    <div className="pa3" data-testid="search-subject-results">
      <Caps as="h2">Subjects</Caps>
      {!results.subjects.length ? (
        <div className="bt b--light-gray pv3 serif tan i f6">No matches found</div>
      ) : (
        <ul className="list pa0 bt b--light-gray">
          {results.subjects.map(subject => (
            <ListItem
              key={subject.node.id}
              {...subject.node}
              href={`/notebook/subject/${subject.node.id}`}
            />
          ))}
        </ul>
      )}
    </div>

    <div className="pa3" data-testid="search-tracker-results">
      <Caps as="h2">Trackers</Caps>
      {!results.trackers.length ? (
        <div className="bt b--light-gray pv3 serif tan i f6">No matches found</div>
      ) : (
        <ul className="list pa0 bt b--light-gray">
          {results.trackers.map(tracker => (
            <ListItem
              key={tracker.node.id}
              {...tracker.node}
              href={`/notebook/tracker/${tracker.node.id}`}
            />
          ))}
        </ul>
      )}
    </div>

    <div className="pa3" data-testid="search-entries-results">
      <Caps as="h2">Entries</Caps>
      {!results.notes.length ? (
        <div className="bt b--light-gray pv3 serif tan i f6">No matches found</div>
      ) : (
        <>
          {results.notes.map(note => (
            <Link
              to={`/notebook/note/${note.node.id}`}
              key={note.node.id}
              className="db navy ba b--light-gray mv3 ph4 pv3"
            >
              <p className="serif f6 lh-copy">{note.node.content}</p>
            </Link>
          ))}
        </>
      )}
    </div>
  </NotebookLayout>
);

export default SearchS;
